export let token = document.cookie.replace(/(?:(?:^|.*;\s*)'micro'\s*\=\s*([^;]*).*$)|^.*$/, "$1");
// export let userRoleId = document.cookie.replace(/(?:(?:^|.*;\s*)user\s*\=\s*([^;]*).*$)|^.*$/, "$1");
export let userRoleName = document.cookie.replace(/(?:(?:^|.*;\s*)user\s*\=\s*([^;]*).*$)|^.*$/, "$1");